import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";
import { MonthlyStateComponent } from "../components/Layout/MonthlyStateComponent/MonthlyStateComponent";
import { PageWrapper } from "../components/PageWrapper/PageWrapper";
import { Header } from "../components/Layout/Header/Header";

export const MonthlyStates = () => {
  return (
    <React.Fragment style={{ padding: "0" }}>
      <Header title={"Reportes mensuales"}></Header>
      <MonthlyStateComponent title={"Reportes mensuales"} />
    </React.Fragment>
  );
};
